(function () {
  var dragState = null;

  document.addEventListener('mousemove', function (e) {
    if (!dragState) return;
    var walk = e.pageX - dragState.startX;
    if (Math.abs(walk) > 5) dragState.hasDragged = true;
    dragState.scroll.scrollLeft = dragState.startScrollLeft - walk;
  });

  document.addEventListener('mouseup', function () {
    if (!dragState) return;
    var scroll = dragState.scroll;
    scroll.classList.remove('is-dragging');
    if (dragState.hasDragged) {
      scroll.dataset.justDragged = 'true';
      setTimeout(function () { delete scroll.dataset.justDragged; }, 200);
    }
    dragState = null;
  });

  function updateVariantArrows(scroll) {
    var wrapper = scroll.closest('.product-list-card__variants');
    if (!wrapper) return;
    var prev = wrapper.querySelector('.product-list-card__variants-arrow--prev');
    var next = wrapper.querySelector('.product-list-card__variants-arrow--next');
    var canPrev = scroll.scrollLeft > 1;
    var canNext = scroll.scrollLeft < scroll.scrollWidth - scroll.clientWidth - 1;
    if (prev) prev.classList.toggle('is-visible', canPrev);
    if (next) next.classList.toggle('is-visible', canNext);
  }

  function initVariantScroll(scroll) {
    if (scroll.dataset.scrollInit) return;
    scroll.dataset.scrollInit = '1';

    var wrapper = scroll.closest('.product-list-card__variants');

    scroll.addEventListener('scroll', function () { updateVariantArrows(scroll); });

    var prev = wrapper && wrapper.querySelector('.product-list-card__variants-arrow--prev');
    var next = wrapper && wrapper.querySelector('.product-list-card__variants-arrow--next');

    if (prev) prev.addEventListener('click', function (e) {
      e.stopPropagation();
      scroll.scrollBy({ left: -120, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function (e) {
      e.stopPropagation();
      scroll.scrollBy({ left: 120, behavior: 'smooth' });
    });

    scroll.addEventListener('mousedown', function (e) {
      dragState = { scroll: scroll, startX: e.pageX, startScrollLeft: scroll.scrollLeft, hasDragged: false };
      scroll.classList.add('is-dragging');
    });

    scroll.addEventListener('click', function (e) {
      if (scroll.dataset.justDragged === 'true') {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);

    var ro = new ResizeObserver(function () { updateVariantArrows(scroll); });
    ro.observe(scroll);
    updateVariantArrows(scroll);
    setTimeout(function () { updateVariantArrows(scroll); }, 100);
  }

  function initAll() {
    document.querySelectorAll('.product-list-card__variants-scroll').forEach(initVariantScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
